import React, { forwardRef } from "react";
import { getClassNames } from "../../utils";

type CoreInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    addonAfter?: React.ReactNode;
    search?: boolean;
    addonAfterBorder?: boolean;
};

const CoreInput = forwardRef<HTMLInputElement, CoreInputProps>((props, ref) => {
    const {
        prefix = null,
        suffix = null,
        addonAfter = null,
        search = false,
        className = "",
        addonAfterBorder = true,
        ...restProps
    } = props;

    const classNameAddonAfter = getClassNames("TextInput-group-addon", {
        "addon-after-border": addonAfterBorder,
    });

    return (
        <span className={`${className} TextInput-group-wrapper`}>
            <span className="TextInput-wrapper TextInput-group">
                <span className="TextInput-affix-wrapper">
                    {prefix && (
                        <span className="TextInput-prefix">{prefix}</span>
                    )}
                    <input
                        {...restProps}
                        className={getClassNames(
                            "TextInput",
                            prefix ? "TextInput--prefix" : "",
                            suffix ? "TextInput--suffix" : ""
                        )}
                        ref={ref}
                    />
                    {suffix && (
                        <span className="TextInput-suffix">{suffix}</span>
                    )}
                </span>
                {addonAfter && (
                    <span className={classNameAddonAfter}>{addonAfter}</span>
                )}
            </span>
        </span>
    );
});


export default CoreInput;
